module.exports = __webpack_public_path__ + "img/icon-thunder-truck.904d713e.svg";